import PropTypes from "prop-types";
import React from "react";
import { initialize, stopSubmit } from "redux-form";
import { bookingPropTypes, paymentShape } from "app/utils/propTypes";
import {
	getContextCallCenter,
	getQuoteTotalWithDelta,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import reduxFormSubmitter from "app/utils/form/reduxFormSubmitter";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";
import { bindActionCreators } from "redux";
import { updateEmail } from "app/reducers/emailActionCreators";
import { saveProfileOnPayment } from "app/pages/Account/Profile/profileActionCreators";
import { getStore } from "app/configureStore";
import { isDeepUndefined } from "app/utils/utils";
import isEqual from "lodash/isEqual";
import injectCountries from "app/utils/intl/InjectCountries";
import {
	book,
	bookExternalPayment,
	fetchExternalPaymentCallback,
	updateExternalBookStatus,
} from "app/pages/Booking/Payment/paymentActionCreators";
import Payment from "./Payment.jsx";
import {
	BOOK_EXTERNAL_PAYMENT_STATUS,
	BOOK_STATUS,
	CIVILITY,
	EXTERNAL_PAYMENT_STATUS,
	HTTP_STATUS_CODES,
	OFFER_CONTRACT_TYPES,
	PASSENGER_TYPE,
	PAYMENT_COUPON_TYPE,
	PAYMENT_METHODS,
	PAYMENT_OPTIONS,
	STRATEGY,
	USABLE_CREDITS_STATUS,
} from "app/constants";
import { withRouter } from "react-router-dom";
import pruneEmpty from "app/utils/pruneEmpty";
import { fields, validate } from "app/pages/Booking/Payment/paymentSchema.js";
import validationMessages from "app/utils/form/validationMessages";
import {
	pushTagOnPaymentSubmit,
	sendDataOnFetchProfileSuccess,
	sendTagOn3DSRedirect,
	sendTagOnApiCallbackError,
	sendTagOnExternalPayment,
	sendTagOnPaymentFailed,
	sendTagOnPaymentPageLoad,
} from "app/utils/analytics";
import { shouldGetProfileAtPayment } from "src/@brand/appConstants";
import { logout } from "app/pages/Auth/AuthActions";
import withOAuth from "app/pages/Auth/OAuth/withOAuth";
import {
	getCurrentPaymentMode,
	getCurrentPaymentType,
	getInsurancesSplittedPrice,
	checkForSpecialOffer,
} from "app/pages/Booking/Payment/paymentSelector";
import get from "lodash/get";
import { injectIntl } from "react-intl";
import { buildPaymentPayload, getPaymentErrorMessage } from "app/utils/paymentUtils";
import { BOOK_EXTERNAL_HTML_REQUEST } from "app/actionTypes";
import {
	finishLoadingBar,
	showLoadingBar,
} from "app/pages/.shared/LoadingBar/loadingBarActionCreators";
import { parseQueries } from "app/utils/routerUtils";
import { fetchFicheProduit } from "app/pages/Listing/productActionCreators";
import { isAuthenticated, isOperatorMode } from "app/pages/Auth/authSelectors";
import { getUsableCreditsTotal } from "app/pages/Account/MyCoupons/couponSelector";
import { getVpSaleCode } from "app/reducers/partnerDataSelector";
import { showFlexRatesModal, preBook } from "app/pages/Booking/Quotation/quotationActionCreators";
import { parsePhoneNumber } from "react-phone-number-input/max";
import { fetchSDPAccommodationDescription } from "app/pages/SmartDP/smartDPActionCreators";
import { getBrandDisplayName } from "app/reducers/partnerSelector";

class PaymentContainer extends React.Component {
	constructor() {
		super();
		this.handleExternalPaymentStatus = this.handleExternalPaymentStatus.bind(this);
		this.onFetchProfilSuccess = this.onFetchProfilSuccess.bind(this);
		this.onFetchProfilFail = this.onFetchProfilFail.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		/**
		 * On veut vider les informations de cartes pour effacer les messages
		 * d'erreur relatifs au mode de paiement précédemment selectionné.
		 * Code voué à disparaître. On n'a pas d'autre choix que de `onChange`
		 * chaque champs voulu.
		 */
		if (
			nextProps.booking.paymentType !== this.props.booking.paymentType ||
			nextProps.booking.paymentMode !== this.props.booking.paymentMode
		) {
			this.props.fields.payment.card.number.onChange("");
			this.props.fields.payment.card.cvc.onChange("");
			this.props.fields.payment.card.expiryMonth.onChange("");
			this.props.fields.payment.card.expiryYear.onChange("");
			this.props.fields.payment.card.holderName.onChange("");
			this.props.fields.payment.card.maidenName.onChange("");
			this.props.fields.payment.card.birthdate.day.onChange("");
			this.props.fields.payment.card.birthdate.month.onChange("");
			this.props.fields.payment.card.birthdate.year.onChange("");
			this.props.fields.payment.card.zipCodeOfBirth.onChange("");
			this.props.fields.payment.cardBCMC.number.onChange("");
			this.props.fields.payment.cardBCMC.cvc.onChange("");
			this.props.fields.payment.cardBCMC.expiryMonth.onChange("");
			this.props.fields.payment.cardBCMC.expiryYear.onChange("");
			this.props.fields.payment.cardBCMC.holderName.onChange("");
		}
	}

	handleExternalPaymentStatus() {
		const {
			showExternalPaymentError,
			bookExternalPayment,
			updateExternalBookStatus,
			strategy,
			logout,
			history,
			updateEmail,
			booking,
			quotationCode,
			payment,
			location = {},
			matchUrl,
		} = this.props;

		const query = parseQueries(location.search);
		const externalPaymentStatus = query.externalPaymentStatus;

		if (externalPaymentStatus) {
			updateExternalBookStatus(externalPaymentStatus);

			if (
				externalPaymentStatus === EXTERNAL_PAYMENT_STATUS.EXTERNAL_PAYMENT_STATUS_ERROR ||
				externalPaymentStatus === EXTERNAL_PAYMENT_STATUS.EXTERNAL_PAYMENT_STATUS_ABORTED
			) {
				sendTagOnExternalPayment(externalPaymentStatus);
				showExternalPaymentError(externalPaymentStatus);
			} else if (
				externalPaymentStatus === EXTERNAL_PAYMENT_STATUS.EXTERNAL_PAYMENT_STATUS_PENDING
			) {
				bookExternalPayment({
					code: quotationCode,
				})
					.then(response => {
						if (response.status === HTTP_STATUS_CODES.OK) {
							const bookExternalPaymentStatus = response.data.status;
							const email = get(booking, "contact.email");

							sendTagOnExternalPayment(bookExternalPaymentStatus);

							if (
								bookExternalPaymentStatus === BOOK_STATUS.SUCCESS ||
								bookExternalPaymentStatus ===
									BOOK_STATUS.WARNING_BOOKING_OK_FULLPAYMENT_FAILED ||
								bookExternalPaymentStatus ===
									BOOK_STATUS.WARNING_BOOKING_FAILED_FULLPAYMENT_OK ||
								bookExternalPaymentStatus ===
									BOOK_STATUS.WARNING_BOOKING_FAILED_FULLPAYMENT_FAILED ||
								bookExternalPaymentStatus === BOOK_STATUS.TECHNICAL_FAILURE
							) {
								const insurance = payment.insurances.insurancesItem.find(
									insurance => {
										return insurance.code === booking.insurance.code;
									}
								);

								// 	Pour préremplir le champ email de la page de confirmation
								updateEmail(email);

								history.push({
									pathname: `${matchUrl}/confirmation`,
									state: {
										bookingReference: get(response, "data.bookingReference"),
										status: bookExternalPaymentStatus,
										email,
										insuranceName: insurance && insurance.name,
										paymentMode: booking.paymentMode,
										paymentType: booking.paymentType,
									},
								});
							} else if (
								bookExternalPaymentStatus === BOOK_STATUS.DUPLICATE_BOOKING
							) {
								const existingBooking = response.data.existingBooking || {};
								history.push({
									pathname: "/technical-error/duplicate-booking",
									state: {
										existingBooking: {
											...existingBooking,
											email: email,
										},
									},
								});
							} else {
								showExternalPaymentError(bookExternalPaymentStatus);
							}
						} else if (response.status === HTTP_STATUS_CODES.FORBIDDEN) {
							logout();
							sendTagOnExternalPayment(response.status);
							if (strategy !== STRATEGY.OAUTH) {
								history.push("/home/login");
							} else {
								history.push("/technical-error/sso");
							}
						} else {
							const httpErrorMessage = get(response, "data.message");
							sendTagOnExternalPayment(response.status);
							history.push({
								pathname: "/technical-error",
								state: {
									errorMessage: httpErrorMessage,
								},
							});
						}
					})
					.catch(error => {
						sendTagOnApiCallbackError("/bookExternalPayment", error);
						history.push({
							pathname: "/technical-error",
						});
					});
			}
		}
	}

	onFetchProfilSuccess() {
		const { location } = this.props;
		const query = parseQueries(location.search);
		const externalPaymentStatus = query.externalPaymentStatus;
		this.props.initializeForm(this.props.formInitialValues);
		// on doit absolument récupérer les crédits après un getProfile
		// car le back end met à jour les crédits lors du getProfile
		sendDataOnFetchProfileSuccess();
		// Attention, il faut appeler handleExternalPaymentStatus après initializeForm sinon le message d'erreur est masqué
		// surtout si externalPaymentStatus=EXTERNAL_PAYMENT_STATUS_ERROR
		this.handleExternalPaymentStatus(externalPaymentStatus);
	}

	onFetchProfilFail() {
		const { location } = this.props;
		const query = parseQueries(location.search);
		const externalPaymentStatus = query.externalPaymentStatus;
		this.props.initializeForm(this.props.formInitialValues);
		// Attention, il faut appeler handleExternalPaymentStatus après initializeForm sinon le message d'erreur est masqué
		// surtout si externalPaymentStatus=EXTERNAL_PAYMENT_STATUS_ERROR
		this.handleExternalPaymentStatus(externalPaymentStatus);
	}

	componentDidUpdate(prevProps) {
		const { total, payment, fields, updateBooking, location } = this.props;
		const prevQuery = parseQueries(prevProps.location.search);
		const query = parseQueries(location.search);

		// On verifie si le montant depasse le max autorise pour un paiement en 4 fois via casino.
		// Si c'est le cas, on desactive le paiement en 4 fois et on selectionne par defaut le paiement en totalite
		// Ici c'est necessaire dans le cas ou le user est sur la page de paiement puis retourne sur la page de devis pour
		// choisir d'autres prestations dont les prix en supplements pourraient augmenter le montant total du panier jusqu'a
		// depasser le total max autorise par casino
		const isPayment4FoisForbidden =
			total < payment.payment4x.minAmount || total > payment.payment4x.maxAmount;
		if (isPayment4FoisForbidden && fields.payment.type.value === PAYMENT_METHODS.CASINO) {
			fields.payment.type.onChange(PAYMENT_METHODS.CARD);
			fields.payment.mode.onChange(String(PAYMENT_OPTIONS["1x"]));

			updateBooking({
				paymentType: PAYMENT_METHODS.CARD,
				paymentMode: PAYMENT_OPTIONS["1x"],
			});
		}

		// Dès que l'on reçoit la liste des pays, on initialise le champs Pays de résidence
		// Désactivé pour l'instant car lorsque l'on est dans le cas de ?externalPaymentStatus=EXTERNAL_PAYMENT_STATUS_ERROR
		// this.props.initializeForm efface les erreurs dns l'interface
		// if (this.props.countries !== prevProps.countries) {
		// 	this.props.initializeForm(this.props.formInitialValues);
		// }

		// pour le scoring casino
		if (
			prevQuery.externalPaymentStatus !== query.externalPaymentStatus &&
			query.externalPaymentStatus
		) {
			this.handleExternalPaymentStatus(query.externalPaymentStatus);
		}
	}

	componentDidMount() {
		const {
			location,
			ficheProduit,
			fetchFicheProduit,
			initializeForm,
			formInitialValues,
			booking,
			payment,
			updateBooking,
			isSDP,
			fetchSDPAccommodationDescription,
			smartDPCode,
		} = this.props;
		const query = parseQueries(location.search);

		if (isSDP && ficheProduit.id && smartDPCode) {
			fetchSDPAccommodationDescription({
				code: smartDPCode,
				accommodationId: ficheProduit.id,
			});
		} else if (ficheProduit.uri) {
			// fetch product info for booking aside product data like photos, name and destination
			fetchFicheProduit({ productUri: ficheProduit.uri });
		}

		// Dans le cas où shouldGetProfileAtPayment = true, alors on appelle deja initializeForm (voir onFetchProfilSuccess et onFetchProfilFail)
		// Il faut s'assurer que pour les brand où la récupération du profile n'a pas lieu,
		// alors il faut quand même initialiser le formulaire
		if (!shouldGetProfileAtPayment()) {
			initializeForm(formInitialValues);
		}

		if (query.externalPaymentStatus) {
			// Attention, il faut appeler handleExternalPaymentStatus après initializeForm sinon le message d'erreur est masqué
			// surtout si externalPaymentStatus=EXTERNAL_PAYMENT_STATUS_ERROR
			this.handleExternalPaymentStatus();
		} else {
			// ne pas envoyer de tag payment_page quand on revient depuis notre partenaire multi payment
			// timeout pour que le tag arrive après celui du virtualPageLoading
			setTimeout(() => {
				sendTagOnPaymentPageLoad();
			}, 100);
		}

		// En effet, si le user va sur la page quote depuis une page paiement en ayant sélectionné une assurance,
		// Si il choisit d'autres prestations sur la page de quote, le prix de l'assurance peut varier une fois qu'il va
		// sur la page de paiement.
		if (booking.insurance.code) {
			const insurance = payment.insurances.insurancesItem.find(
				payment => payment.code === booking.insurance.code
			);

			if (insurance) {
				updateBooking({
					insurance,
				});
			}
		}
	}

	componentWillUnmount() {
		this.props.finishLoadingBar();
	}

	render() {
		return (
			<Payment
				{...this.props}
				onFetchProfilSuccess={this.onFetchProfilSuccess}
				onFetchProfilFail={this.onFetchProfilFail}
			/>
		);
	}
}

PaymentContainer.propTypes = {
	isAuthenticated: PropTypes.bool,
	enableSponsorship: PropTypes.bool,
	profile: PropTypes.object,
	payment: paymentShape,
	fields: PropTypes.object,
	total: PropTypes.number,
	strategy: PropTypes.string,
	quotationCode: PropTypes.string,
	token: PropTypes.string,
	booking: bookingPropTypes,
	formInitialValues: PropTypes.object,
	initializeForm: PropTypes.func,
	updateExternalBookStatus: PropTypes.func,
	updateEmail: PropTypes.func,
	showExternalPaymentError: PropTypes.func,
	bookExternalPayment: PropTypes.func,
	logout: PropTypes.func,
	updateBooking: PropTypes.func,
	finishLoadingBar: PropTypes.func,
	countries: PropTypes.array,
	history: PropTypes.shape({ push: PropTypes.func, replace: PropTypes.func }),
	allowedPaymentTypes: PropTypes.arrayOf(PropTypes.string),
	fetchFicheProduit: PropTypes.func,
	ficheProduit: PropTypes.object,
	matchUrl: PropTypes.object,
	fetchSDPAccommodationDescription: PropTypes.func,
	isSDP: PropTypes.bool,
	smartDPCode: PropTypes.string,
};

const beforeValidateForm = (values, dispatch) => {
	const state = getStore().getState();

	values.passengers.forEach(passenger => {
		// pour les adultes, la date de naissance n'est pas obligatoire si dateOfBirthRequired = false
		// hack pour valider un item d'un array de maniere conditionnel
		// La fonction de validation customIsRequiredIf ne valide pas si value="novalidate"
		if (passenger.type === PASSENGER_TYPE.ADULT && state.payment.dateOfBirthRequired !== true) {
			passenger.birthdate.day = "novalidate";
			passenger.birthdate.month = "novalidate";
			passenger.birthdate.year = "novalidate";
		}
	});

	if (values.contact.name.gender === CIVILITY.MALE) {
		values.payment.card.maidenName = "novalidate";
	}

	// on souhaite persister les données saisies si on revient sur la page paiement avant d'avoir la confirmation de réservation
	// exemple : reload, annulation depuis un partenaire externe et redirection sur la page de paiement, erreur de book
	dispatch(
		updateBooking({
			paymentType: values.payment.type,
			contact: values.contact,
			passengers: values.passengers,
		})
	);
};

const beforeSubmit = (values, ownsProps, dispatch) => {
	const state = getStore().getState();
	const strategy = state.partner.strategy;
	const profile = state.profile;
	const mapFormToPayload = values => {
		const payload = Object.assign({}, values.contact);
		// on met a jour la numero de telephone dans l'adresse car c'est celle-ci qui est attendu par le service /saveProfile
		payload.address.phone = values.contact.phone;
		// on supprime les propriétés inutiles sinon erreur 400 du service /saveProfile
		delete payload.phone;
		delete payload.email;
		return payload;
	};

	const payload = mapFormToPayload(values);

	if (
		strategy !== STRATEGY.TRANSACTION_FIRST &&
		(!isEqual(pruneEmpty(profile.name), pruneEmpty(payload.name)) ||
			!isEqual(pruneEmpty(profile.address), pruneEmpty(payload.address)))
	) {
		dispatch(saveProfileOnPayment(payload, true));
	}

	dispatch(showLoadingBar());
};

const onSubmitSuccess = (response, ownProps, dispatch, values) => {
	// Ici on passe les données pour l'envoi de tag analytics à la page de confirmation
	// via le state de react-router

	if (response.status === HTTP_STATUS_CODES.OK) {
		// dans le cas du payment en plusieurs fois, on redirige vers le site du partenaire
		if (response.data.redirectPaymentURL && response.data.status === BOOK_STATUS.SUCCESS) {
			window.location = response.data.redirectPaymentURL;
		} else if (response.data.status === BOOK_STATUS.DUPLICATE_BOOKING) {
			const existingBooking = response.data.existingBooking || {};
			ownProps.history.push({
				pathname: "/technical-error/duplicate-booking",
				state: {
					existingBooking: {
						...existingBooking,
						email: values.contact.email,
					},
				},
			});
		} else if (
			response.data.status === BOOK_STATUS.EXTERNAL_REDIRECT_REQUEST &&
			response.data.externalUrl
		) {
			sendTagOn3DSRedirect();
			ownProps.history.replace({
				pathname: "/external-redirect",
				state: {
					redirectParams: response.data.params,
					externalUrl: response.data.externalUrl,
					redirectMethod: response.data.redirectMethod,
				},
			});
		} else if (
			response.data.status === BOOK_STATUS.EXTERNAL_HTML_REQUEST &&
			response.data.htmlPayload // scoring casino et (3DS2)
		) {
			dispatch({
				type: BOOK_EXTERNAL_HTML_REQUEST,
			});

			const { callbackDelay, htmlPayload } = response.data;
			const callbackUrl = response.data.callback_url;

			fetchExternalPaymentCallback({
				callbackDelay,
				callbackUrl,
				htmlPayload,
			})
				.then(({ externalPaymentStatus, response }) => {
					dispatch(finishLoadingBar());

					// handle double external redirect for 3ds casino
					if (externalPaymentStatus === BOOK_STATUS.EXTERNAL_REDIRECT_REQUEST) {
						sendTagOn3DSRedirect();
						ownProps.history.replace({
							pathname: "/external-redirect",
							state: {
								redirectParams: response.data.params,
								externalUrl: response.data.externalUrl,
								redirectMethod: response.data.redirectMethod,
							},
						});
					} else if (externalPaymentStatus) {
						ownProps.history.replace({
							pathname: `${ownProps.matchUrl}/payment`,
							search: `?externalPaymentStatus=${externalPaymentStatus}`,
						});
					}
				})
				.catch(() => {
					ownProps.history.replace({
						pathname: `${ownProps.matchUrl}/payment`,
						search: `?externalPaymentStatus=${
							BOOK_STATUS.EXTERNAL_PAYMENT_STATUS_ERROR
						}`,
					});
					dispatch(finishLoadingBar());
				});
		} else {
			const state = getStore().getState();
			const insurance = state.payment.insurances.insurancesItem.find(
				insurance => insurance.code === values.insurance
			);

			// Pour préremplir le champ email de la page de confirmation
			dispatch({
				type: "SET_EMAIL",
				email: values.contact.email,
			});

			const paymentMode = values.payment.mode;
			const paymentType = values.payment.type;

			ownProps.history.push({
				pathname: `${ownProps.matchUrl}/confirmation`,
				state: {
					bookingReference: response.data.bookingReference,
					status: response.data.status,
					email: values.contact.email,
					insuranceName: insurance && insurance.name,
					paymentMode,
					paymentType,
				},
			});
		}
	}
};

const onSubmitFail = (response, ownProps, reject, dispatch) => {
	const httpStatus = response.status;
	const httpErrorMessage = get(response, "data.message");

	const isHttpError =
		!httpStatus ||
		httpStatus === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR ||
		httpStatus === HTTP_STATUS_CODES.GATEWAY_TIMEOUT ||
		httpStatus === HTTP_STATUS_CODES.BAD_REQUEST;

	const state = getStore().getState();
	const contextCallCenter = getContextCallCenter({
		isPaymentPage: true,
	})(state);

	const phoneNumber = contextCallCenter.displayPhone
		? contextCallCenter.displayPhone.join(" ")
		: "";

	if (isHttpError) {
		ownProps.history.push({
			pathname: "/technical-error",
			state: {
				errorMessage: httpErrorMessage,
			},
		}); // push car on veut que le back navigateur retourne sur la page de paiement
	} else if (httpStatus === HTTP_STATUS_CODES.FORBIDDEN) {
		dispatch(logout());
		if (ownProps.strategy === STRATEGY.OAUTH) {
			ownProps.history.push({ pathname: "/technical-error/sso" });
		} else if (ownProps.strategy === STRATEGY.TRANSACTION_FIRST) {
			ownProps.history.push({
				pathname: "/technical-error",
				state: {
					errorMessage: httpErrorMessage,
				},
			});
		} else {
			ownProps.history.push({
				pathname: "/booking/auth",
				search: `?onauthsuccess=${ownProps.location.pathname}`,
			}); // replace pour éviter un back navigateur sur la page de quotation
		}
	} else {
		dispatch(finishLoadingBar());
		reject({ _error: getPaymentErrorMessage(response, phoneNumber) });
	}

	if (isHttpError) {
		sendTagOnPaymentFailed(httpStatus);
	} else if (response.data.status) {
		sendTagOnPaymentFailed(response.data.status, response.data.paymentType);
	}
};

const reduxFormConfig = {
	form: "booking-payment-form",
	fields,
	beforeValidateForm,
	validateForm: values => {
		values.passengers.forEach((passenger, passengerIndex) => {
			values.passengers[passengerIndex].name.fullName = `${passenger.name.firstName ||
				""}${passenger.name.lastName || ""}`;
		});

		const state = getStore().getState();
		const errors = validate(values, state);
		const noInsurance =
			get(state, "payment.insurances.insurancesItem.length") === 1 &&
			get(state, "payment.insurances.insurancesItem[0].price") === 0;
		const insurance = noInsurance
			? get(state, "payment.insurances.insurancesItem[0]")
			: state.payment.insurances.insurancesItem.find(
					insurance => insurance.code === values.insurance
			  );

		const paymentMode = values.payment.mode;
		const paymentType = values.payment.type;

		const paymentData = {
			insuranceName: insurance && insurance.name,
			hasFormErrors: !isDeepUndefined(errors),
			paymentMode,
			paymentType,
		};

		if (paymentData.hasFormErrors) {
			paymentData.formErrors = JSON.stringify(pruneEmpty(errors));
		}

		pushTagOnPaymentSubmit(paymentData);

		return errors;
	},
	mapFormToPayload: (values, ownProps, state) => {
		return buildPaymentPayload(values, state, window.location.origin);
	},
	actionCreator: book,
	beforeSubmit,
	onSubmitSuccess,
	onSubmitFail,
};

const mapStateToProps = (state, props) => {
	const isRental = state.booking.offer.contractType === OFFER_CONTRACT_TYPES.RENTAL;
	const profile = state.profile;

	const token = state.auth.token;

	const strategy = state.partner.strategy;

	const total = getQuoteTotalWithDelta(state);

	const initialPaymentTypeValue = getCurrentPaymentType(state);

	const initialPaymentModeValue = getCurrentPaymentMode(state);

	const showInsurancesSection = get(state, "payment.insurances.insurancesItem.length") > 1;

	const usableCouponsStatus = state.usableCoupons.status;
	const totalUsableCredit = getUsableCreditsTotal(state);
	const isOperator = isOperatorMode(state);
	const enablePromotionCode = isOperator || state.partner.enablePromotionCode;

	const defaultCouponType =
		usableCouponsStatus === USABLE_CREDITS_STATUS.SUCCESS &&
		enablePromotionCode &&
		!totalUsableCredit
			? PAYMENT_COUPON_TYPE.PROMOCODE
			: PAYMENT_COUPON_TYPE.CREDIT;

	const formInitialValues = {
		payment: {
			mode: initialPaymentModeValue && initialPaymentModeValue.toString(),
			type: initialPaymentTypeValue,
			card: {
				cvc: "",
			},
		},
		coupon: state.booking.coupon ? state.booking.coupon : defaultCouponType,
		insurance: showInsurancesSection
			? state.booking.insurance.code
			: get(state, "payment.insurances.insurancesItem[0].code"),
		contact: state.booking.contact
			? {
					email: state.booking.contact.email,
					name: state.booking.contact.name,
					address: { ...state.booking.contact.address },
					phone: state.booking.contact.phone ? state.booking.contact.phone : undefined,
			  }
			: {
					email:
						strategy === STRATEGY.TRANSACTION_FIRST && !state.auth.tokenFromPartner
							? undefined
							: state.email,
					name: profile.name,
					address: { ...profile.address },
					phone: profile.address ? profile.address.phone : undefined,
			  },
	};

	// on format le numero de tel avec l'indicatif de la shop avant de l'afficher.
	// si le numero n'a pas d'indicatif, alors sans ce code, on a le drapeau international d'affiché
	// au lieu du drapeau correspondant à celui de la shop
	if (
		get(formInitialValues, "contact.phone") &&
		get(formInitialValues, "contact.phone.length") > 0
	) {
		const numberAnalysis = parsePhoneNumber(
			formInitialValues.contact.phone,
			state.shop.slice(3, 5)
		);
		if (numberAnalysis) {
			formInitialValues.contact.phone = numberAnalysis.number;
		}
	}

	// Si on a aucun pays de residence, alors on initialise au pays correspond à la shop
	if (!get(formInitialValues, "contact.address.country")) {
		const initialCountry = props.countries.find(country => {
			return country.cca2 === state.shop.slice(3, 5);
		});

		if (initialCountry) {
			formInitialValues.contact.address.country = initialCountry.cca2; //cca2 code pays sur 2 lettres "FR"
		}
	}

	if (!isRental) {
		const passengers = state.booking.passengers;

		const adultPassengers = passengers.filter(
			passenger => passenger.type === PASSENGER_TYPE.ADULT
		);
		const childPassengers = passengers.filter(
			passenger => passenger.type === PASSENGER_TYPE.CHILD
		);
		const infantPassengers = passengers.filter(
			passenger => passenger.type === PASSENGER_TYPE.INFANT
		);

		const passengersFields = adultPassengers.concat(childPassengers).concat(infantPassengers);

		formInitialValues.passengers = passengersFields;
	}

	const isSDP = props.match.path.includes("/sdp/booking/payment");

	return {
		isSDP,
		smartDPCode: state.smartDP.code,
		brand: state.brand.code,
		shop: state.shop,
		cartAmount: getQuoteTotalWithDelta(state),
		selectedPaymentType: state.booking.paymentType,
		booking: state.booking,
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		quotationCode: state.quotation.code,
		total: total,
		token: token,
		profile: profile,
		payment: { ...state.payment, insurances: getInsurancesSplittedPrice(state) },
		resolution: state.resolution,
		productUri: state.ficheProduit.uri,
		showFrequentTravellerCardInput: state.payment.showFrequentTravellerCardInput,
		dateOfBirthRequired: state.payment.dateOfBirthRequired,
		contractRemarks: state.payment.contractRemarks,
		isChildrenAgeRequired: state.ficheProduit.isChildAgeRequired || isSDP,
		isAuthenticated: isAuthenticated(state),
		enableSponsorship: state.partner.enableSponsorship,
		strategy: strategy,
		email:
			strategy === STRATEGY.TRANSACTION_FIRST && !state.auth.tokenFromPartner
				? undefined
				: state.email, // Autorise ou non la saisie de l'email
		formInitialValues,
		showInsurancesSection,
		partnerCode: state.partner.code,
		vpSaleCode: getVpSaleCode(state),
		ficheProduit: state.ficheProduit,
		usableCouponsStatus: state.usableCoupons.status,
		isSpecialOfferActive: checkForSpecialOffer(state),
		isOperatorMode: isOperator,
		brandDisplayName: getBrandDisplayName(state),
	};
};

const madDispatchToProps = dispatch => {
	return Object.assign(
		{},
		{
			initializeForm: initializeValues => {
				dispatch(initialize("booking-payment-form", initializeValues));
			},
			showExternalPaymentError: status => {
				if (status === BOOK_EXTERNAL_PAYMENT_STATUS.BOOK_EXTERNAL_PAYMENT_STATUS_REFUSED) {
					dispatch(
						stopSubmit("booking-payment-form", {
							_error: {
								id: "error.payment.external.technical.error.not.enough.balance",
							},
						})
					);
				} else if (status === BOOK_STATUS.SESSION_EXPIRED) {
					dispatch(
						stopSubmit("booking-payment-form", {
							_error: {
								id: "error.booking.session.expired",
							},
						})
					);
				} else if (
					status === EXTERNAL_PAYMENT_STATUS.EXTERNAL_PAYMENT_STATUS_ERROR ||
					status === BOOK_EXTERNAL_PAYMENT_STATUS.BOOK_EXTERNAL_PAYMENT_TECHNICAL_ERROR
				) {
					const state = getStore().getState();
					const contextCallCenter = getContextCallCenter({
						isPaymentPage: true,
					})(state);

					const phoneNumber = contextCallCenter.displayPhone
						? contextCallCenter.displayPhone.join(" ")
						: "";
					dispatch(
						stopSubmit("booking-payment-form", {
							_error: {
								id: validationMessages.externalPaymentError.id,
								values: { telephone: phoneNumber },
							},
						})
					);
				} else if (status === BOOK_STATUS.CREDIT_CARD_INFO) {
					dispatch(
						stopSubmit("booking-payment-form", {
							_error: {
								id: "error.payment.credit.card.info",
							},
						})
					);
				} else if (status === BOOK_STATUS.CREDIT_CARD_TECHNICAL_ERROR) {
					dispatch(
						stopSubmit("booking-payment-form", {
							_error: {
								id: "error.payment.technical.error",
							},
						})
					);
				} else if (status === BOOK_STATUS.CREDIT_CARD_REFUSED) {
					dispatch(
						stopSubmit("booking-payment-form", {
							_error: {
								id: "error.payment.credit.card.refused.not.enough.balance",
							},
						})
					);
				}
			},
		},
		bindActionCreators(
			{
				logout,
				updateEmail,
				bookExternalPayment,
				updateExternalBookStatus,
				updateBooking,
				finishLoadingBar,
				showLoadingBar,
				fetchFicheProduit,
				showFlexRatesModal,
				preBook,
				fetchSDPAccommodationDescription,
			},
			dispatch
		)
	);
};

export default withOAuth(
	injectIntl(
		injectCountries(
			withRouter(
				reduxFormSubmitter(reduxFormConfig, mapStateToProps, madDispatchToProps)(
					PaymentContainer
				)
			)
		)
	)
);
